import * as _ from "lodash";
import * as angular from "angular";
import { VoterFileService } from "../services/voter-file.service";
export class VoterFileImport {
    private readonly $q: any;
    private readonly service: VoterFileService;
    public readonly uploadingStatuses = [1, 2];
    public readonly inProgressStatuses = [2, 3, 4, 5, 12, 14];
    public readonly importingStatuses = [4, 5, 12, 14];
    public readonly warningStatuses = [8, 9, 15, 16];
    public imid: string | number | null = null;
    public imsstatus: string | null = null;
    public status: string | null = null;
    public imsid: string | number | null = null;
    public improgress: string | number | null = null;
    public imname: string | null = null;
    public erid: string | number | null = null;
    public erfilename: string;
    public creator?: any;
    public updater?: any;
    public data?: any;
    public file?: any;
    public mapping?: any;
    public uid: string | number | null;
    public ufname: string;
    public ulname: string;
    public finished: string | number | null;
    public total: string | number | null;
    public creationdatetime: string | number | null;
    public lastmodifieddatetime: string | number | null;
    public ertimestamp: string | number | null;

    constructor(VoterFileService: VoterFileService, $q: any, data?: any) {
        this.service = VoterFileService;
        this.$q = $q;
        this.setData(data);
    }

    setData(data?: object): void {
        if (data) {
            _.merge(this, data, data["attributes"]);
        }
    }

    getFileData(): Promise<any> {
        const deferred = this.$q.defer();
        this.service.data({ id: this.erid }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success && angular.isDefined(json.data)) {
                    this.data = json.data;
                    deferred.resolve();
                } else {
                    deferred.reject();
                }
            },
            (error: any) => deferred.reject(error)
        );
        return deferred.promise;
    }

    getMapping(): Promise<any> {
        const deferred = this.$q.defer();
        this.service.mapping({ id: this.imid }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success && angular.isDefined(json.data)) {
                    this.mapping = json.data;
                    deferred.resolve();
                } else {
                    deferred.reject();
                }
            },
            (error: any) => deferred.reject(error)
        );
        return deferred.promise;
    }

    inProgress(): boolean {
        if (this.statusid()) {
            return (
                this.inProgressStatuses.indexOf(parseInt(this.statusid())) > -1
            );
        }
        return false;
    }

    importInProgress(): boolean {
        if (this.statusid()) {
            return (
                this.importingStatuses.indexOf(parseInt(this.statusid())) > -1
            );
        }
        return false;
    }

    hasWarning(): boolean {
        if (this.statusid()) {
            return this.warningStatuses.indexOf(parseInt(this.statusid())) > -1;
        }
        return false;
    }

    statusString(): string {
        return this.imsstatus;
    }

    statusid(): any {
        return this.imsid;
    }

    complete(): boolean {
        return this.statusid() == 7;
    }

    error(): boolean {
        return (
            this.readError() || this.statusid() == 9 || this.statusid() == 15
        );
    }

    readError(): boolean {
        return this.imsid == 8;
    }

    limitError(): boolean {
        return this.imsid == 15;
    }

    progress(): string | number {
        return this.improgress;
    }

    sizeError(): boolean {
        return this.imsid == 16;
    }

    name(): string {
        return this.imname ? this.imname : this.erfilename;
    }

    fileExtension(): string {
        return this.file ? "." + this.file.erfiletype : "";
    }

    readyToImport(): boolean {
        return (
            !!this.imid ||
            !(this.uploadingStatuses.indexOf(parseInt(this.statusid())) > -1)
        );
    }

    creatorName(): string {
        return (this.ufname || "") + " " + (this.ulname || "");
    }
    updaterName(): string {
        return (this.updater.ufname || "") + " " + (this.updater.ulname || "");
    }

    numFinished(): string | number | null {
        return this.finished;
    }

    numTotal(): string | number | null {
        return this.total;
    }

    updatedAt(): string | number | null {
        return this.lastmodifieddatetime
            ? this.lastmodifieddatetime
            : this.createdAt();
    }

    createdAt(): string | number | null {
        return this.creationdatetime ? this.creationdatetime : this.ertimestamp;
    }

    isDeleted(): boolean {
        return this.status == "Deleted";
    }

    // Set while the background delete job runs (AV-18260)
    isDeleting(): boolean {
        return this.status == "Deleting";
    }

    // Some of the import's data may be gone; deleting again finishes it
    deleteFailed(): boolean {
        return this.status == "Delete Failed";
    }

    hasDeleteStatus(): boolean {
        return this.isDeleted() || this.isDeleting() || this.deleteFailed();
    }

    // The import's own status no longer describes its data
    statusLabel(): string {
        if (this.hasDeleteStatus()) {
            return this.status;
        }
        return this.statusid() == 3 ? "Ready To Import" : this.statusString();
    }
}
